import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type { EditorContentFragmentResult } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { useEmojiEverSetPropertyQuery$data } from './__generated__/useEmojiEverSetPropertyQuery.graphql.ts';
import type { useEmojiEverSetPropertyFragment_content$key } from './__generated__/useEmojiEverSetPropertyFragment_content.graphql.ts';

// useEmojiEverSetPropertyQuery's selection for EditorContentUnifiedQuery; same fields and
// arguments, so both share the store records.
const emojiEverSetPropertyFragmentNode: GraphQLTaggedNode = graphql`
	fragment useEmojiEverSetPropertyFragment_content on Content @catch {
		id
		properties(key: "emoji-ever-set") {
			nodes {
				id
				key
				value
			}
		}
	}
`;

/**
 * The emoji-ever-set property from EditorContentUnifiedQuery in the shape of
 * useEmojiEverSetPropertyQuery data. When the fragment is provided, its reader skips
 * useEmojiEverSetPropertyQuery, whose refetch still updates the records the fragment reads.
 */
export function useEmojiEverSetPropertyFragment({
	contentId,
}: {
	contentId: string;
}): EditorContentFragmentResult<useEmojiEverSetPropertyQuery$data> {
	return useEditorContentFragment<
		useEmojiEverSetPropertyFragment_content$key,
		useEmojiEverSetPropertyQuery$data
	>('emojiEverSetPropertyFragment', emojiEverSetPropertyFragmentNode, {
		contentId,
		mapData: (value) => ({ content: { nodes: [value] } }),
	});
}
